module.exports = __webpack_public_path__ + "img/icon-warning-thunder-yellow.33d8e7d9.svg";